<template>
  <div id="app" ref="scrollview">
    <header-bar></header-bar>
    <router-view class="router-view" ></router-view>
    <second-footer  v-if="$route.path!='/login'&&$route.path!='/register'&&$route.path!='/forgetPwd'"></second-footer>
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import SecondFooter from "@/common/SecondFooter.vue";


import router from "@/router";
export default {
  name: 'App',
  components: {
    HeaderBar,FooterBar,SecondFooter
  },
  data(){
    return{
      top:0,
      scrollTop:0
    }
  },
  watch: {
    $route: function ss() {
      let that=this;
      that.getNotice()
    }
  },
  mounted(){
    window.addEventListener("scroll", this.getScroll);
   //let DOMAIN_PREFIX='https://testdoc.scsqzb.cn'
   let DOMAIN_PREFIX='https://'+window.location.hostname
    this.$store.commit('setUrl',DOMAIN_PREFIX)
    this.getNotice()
   // this.checkLogin()
  },
  methods:{
    router() {
      return router
    },
    getNotice(){
      let  token = this.$store.state.token;
      let that=this;
      if (token){
        this.$get('/api/user/unread_changes_log',{}).then(res=>{
          if (res.data.has_message){
            this.$message(res.data.message);
            this.$alert(res.data.message,'提示',{
              confirmButtonText: '确定',
              callback: () => {
                that.$post('/api/user/unread_changes_save',{id:res.data.id})
              }
            })
          }
        })
      }

    },
    getScroll(){
     // console.log(e)
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      this.scrollTop=scrollTop
    },
    toPageTop(){
       this.scrollTop=0;
      document.documentElement.scrollTop=0
    },
    checkLogin() {
      this.$get('/api/authorizations/check').then(() => {
        this.$get('/api/user').then(res=>{
          this.setUserInfos(res.data)
        })
      })
    },
  }
}
</script>

<style lang="scss">
*{
  box-sizing: border-box;
}
::-webkit-scrollbar{width:0 !important;}
.pointer{
  cursor:pointer;
}
.main-button{
  text-align: center;
  color: #fff;
  background: linear-gradient( to right, #1988FF 0%, #1565F7 100%);
  border-radius: 50px 50px 50px 50px;
  cursor: pointer;
}
.text-center{
  text-align: center;
}
#app{
  background-color: #F6F6F6;
  color:#333333;
  el-button{
   border:none
  }
  .empty{
    text-align: center;
    padding-top: 100px;
    img{
      width: 426px;
      height: 426px;
    }
  }
  .common-content{
    width: 1200px;
    margin:35px auto;
    padding: 48px;
    background-color: #fff;
    border-radius: 16px;
    .title{
      font-size: 24px;
      font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
      font-weight: 500;
      color: #333333;
      text-align: center;
    }
    .info{
      font-size: 16px;
      font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
      font-weight: 400;
      color: #333333;
      /deep/ img{
        max-width: 100% !important;
      }
    }
  }
.flex{
  display: flex
}
.flex-items{
  display: flex;
  align-items: center;
}
.flex-center{
  justify-content: center;
}
.flex-between{
  justify-content: space-between;
}
.flex-around{
  justify-content: space-around;
}
  .d-flex{
    display: flex;
  }
  .flex-wrap{
    flex-wrap: wrap;
  }
  .align-items-center{
    align-items: center;
  }
  .js-center{
    justify-content: center;
  }
  .js-between{
    justify-content: space-between;
  }
  .js-end{
    justify-content: flex-end;
  }
  .f1{
    flex:1
  }

}
</style>
